import { render, staticRenderFns } from "./TaskSubmits.vue?vue&type=template&id=bbbc9ef4&scoped=true&"
import script from "./TaskSubmits.vue?vue&type=script&lang=ts&"
export * from "./TaskSubmits.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbbc9ef4",
  null
  
)

export default component.exports